import React, { Fragment } from 'react';
import Radium from 'radium';
import PropTypes from 'prop-types';
import { UTButton, UTLabel } from '@widergy/energy-ui';

import UTBullet from 'app/components/UTBullet';
import { appConfig } from 'config/customization';
import Images from 'config/assets';
import { message } from 'utils/stringUtils';
import { UTILITIES } from 'constants/utilitiesMappers';

import EdenContentLayout from './components/EdenContentLayout';
import ContactItem from './components/ContactItem';
import stylesJS from './styles';
import styles from './styles.module.scss';

function ComplaintsScene({ onAddComplaint }) {
  const contactItems = [
    {
      iconUrl: Images.complaintsContact1,
      contactInfo: message('Complaints:contactItem1'),
      id: 1,
      show: appConfig.complaints.complaintsForm
    },
    {
      iconUrl: Images.complaintsContact2,
      contactInfo: message('Complaints:contactItem2', {
        complaintsPhone: appConfig.complaints.contactPhone
      }),
      phone: appConfig.complaints.contactPhone,
      id: 2,
      show: true
    },
    {
      iconUrl: Images.complaintsContact3,
      contactInfo: message('Complaints:contactItem3', {
        complaintsMail: appConfig.complaints.contactMail
      }),
      id: 3,
      mail: appConfig.complaints.contactMail,
      show: true
    }
  ].filter(element => element.show);

  return (
    <Fragment>
      {appConfig.mappers === UTILITIES.eden ? (
        <EdenContentLayout onAddComplaint={onAddComplaint} />
      ) : (
        <Fragment>
          <div style={[stylesJS.bulletsSection, appConfig.complaints.withLine && stylesJS.withBorder]}>
            <div style={stylesJS.header}>
              <UTLabel large bold>
                {message('Complaints:complaints')}
              </UTLabel>
              {appConfig.complaints.complaintsForm && (
                <UTButton style={stylesJS.addComplaint} onPress={onAddComplaint}>
                  {message('Complaints:crimeComplaint')}
                </UTButton>
              )}
            </div>
            {appConfig.complaints.withSubtitles && (
              <UTLabel semibold className={styles.subtitle}>
                {message('Complaints:complaintSubtitle')}
              </UTLabel>
            )}
            <div style={stylesJS.bulletsContainer}>
              {!appConfig.complaints.withBullets &&
                appConfig.complaints.bullets.map(bullet => (
                  <UTLabel key={bullet.id} style={stylesJS.bullet}>
                    {bullet.content}
                  </UTLabel>
                ))}
            </div>
            {appConfig.complaints.withBullets &&
              appConfig.complaints.bullets.map((bullet, index) => (
                <UTBullet
                  base
                  content={bullet.content}
                  lastItem={index === appConfig.complaints.bullets.length - 1}
                  key={bullet.id}
                />
              ))}
          </div>
          <div style={stylesJS.contactSection}>
            <UTLabel large bold className={styles.subtitle}>
              {message('Complaints:contactTitle')}
            </UTLabel>
            {appConfig.complaints.withSubtitles && (
              <UTLabel light> {message('Complaints:contactSubtitle')}</UTLabel>
            )}
            <div style={stylesJS.contactItems}>
              {contactItems.map(contactItem => (
                <ContactItem
                  mail={contactItem.mail}
                  phone={contactItem.phone}
                  contactItem={contactItem}
                  key={contactItem.id}
                />
              ))}
            </div>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
}

ComplaintsScene.propTypes = {
  onAddComplaint: PropTypes.func.isRequired
};

export default Radium(ComplaintsScene);
